export default __webpack_public_path__ + "static/media/Muli-Regular.e9aab0fd.ttf";